import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import Check from 'mdi-material-ui/Check';
import { useEffect, useState, useRef } from 'react';
import axios from 'src/services/ApiService';
import AuthorizeService from '../../src/components/api-authorization/AuthorizeService';
import { useNavigate } from 'react-router-dom';

export interface Features {

	'Posts Per Month': number;
	'Can Schedule Post': boolean;
	'Instagram': boolean;
	'TikTok': boolean;
	'Facebook': boolean;
	'Twitter': boolean;
	'LinkedIn': boolean;
	'Threads': boolean;
	'Bluesky': boolean;
	'Mastodon': boolean;
	'YouTube': boolean;
	'Google': boolean;
	'Pinterest': boolean;
	'AI Assistant': boolean;
	'Canva': boolean;
	'Post Previews': boolean;
	'Content Scheduling': boolean;
	'Hashtag Manager': boolean;
	'Link Shorteners': boolean;
}

interface Data {
	id: number;
	name: string;
	monthlyCost: number;
	yearlyCost: number;
	channelsLimit: number;
	channelsPrice: number;
}
interface Subscription {
	id: number;
	name: string;
	monthlyCost: number;
	yearlyCost: number;
	channelsLimit: number;
	channelsPrice: number;
	postsPerMonth: number;
	canSchedulePost: boolean;
	instagram: boolean;
	tikTok: boolean;
	facebook: boolean;
	twitter: boolean;
	linkedIn: boolean;
	threads: boolean;
	bluesky: boolean;
	mastodon: boolean;
	youTube: boolean;
	google: boolean;
	pinterest: boolean;
	aiAssistant: boolean;
	canva: boolean;
	postPreviews: boolean;
	contentScheduling: boolean;
	hashtagManager: boolean;
	linkShorteners: boolean;
}

const Subscriptions = () => {

	const [dataList, setDataList] = useState<Data[] | null>(null);
	const [features, setFeatures] = useState<Features[] | null>(null);

	const [alignment, setAlignment] = useState<any>('monthly');
	let [count, setCount] = useState<number>(1);
	const [featureList, setFeatureList] = useState<any>(['Planning & publishing tools', 'Landing page builder', 'AI Assistant']);
	const [userId, setUserId] = useState<any>();
	const [amount, setAmount] = useState<any>();
	const amountEssentials = useRef(0);
	const amountTeam = useRef(0);
	const amountAgency = useRef(0);


	const navigate = useNavigate();


	const handleChange = (
		event: React.MouseEvent<HTMLElement>,
		newAlignment: string,
	) => {
		setAlignment(newAlignment);
	};

	const increment = () => {
		setCount(count + 1);
	}

	const decrement = () => {
		if (count > 1) {
			setCount(count - 1);
		}
	}

	useEffect(() => {
		const fetchSubscriptions = async () => {
			try {
				const response = await axios.get<Subscription[]>('Subscription')

				const dataList = response.data.map(item => ({
					id: item.id,
					name: item.name,
					monthlyCost: item.monthlyCost,
					yearlyCost: item.yearlyCost,
					channelsLimit: item.channelsLimit,
					channelsPrice: item.channelsPrice
				}));

				const featuresList = response.data.map(item => ({
					'Posts Per Month': item.postsPerMonth,
					'Can Schedule Post': item.canSchedulePost,
					'Instagram': item.instagram,
					'TikTok': item.tikTok,
					'Facebook': item.facebook,
					'Twitter': item.twitter,
					'LinkedIn': item.linkedIn,
					'Threads': item.threads,
					'Bluesky': item.bluesky,
					'Mastodon': item.mastodon,
					'YouTube': item.youTube,
					'Google': item.google,
					'Pinterest': item.pinterest,
					'AI Assistant': item.aiAssistant,
					'Canva': item.canva,
					'Post Previews': item.postPreviews,
					'Content Scheduling': item.contentScheduling,
					'Hashtag Manager': item.hashtagManager,
					'Link Shorteners': item.linkShorteners

				}));


				setDataList(dataList);
				setFeatures(featuresList);

			} catch (err: any) {
				console.log(err);
			}
		}

		const getUserDetails = async () => {

			const response = await AuthorizeService.getUser();
			if (response) {
				setUserId(response.sub);
			} else {
				setUserId(null);
			}
		}
		fetchSubscriptions();
		getUserDetails();
	}, [])



	const renderPricing = (planName: string) => {
		let planAmount = 0;
		if (planName == 'Free') {
			return (
				<>
					<Typography variant='h5' component="span">$0</Typography>
					<Typography variant='body2'> Connect up to 3 channels </Typography>
				</>
			)
		}

		if (planName == 'Essentials') {
			let increment = 6;
			alignment == 'monthly' ? increment = 6 : increment = 5;
			amountEssentials.current = increment * count;
			return (
				<>
					<Typography variant='h5' component="span">${increment * count}</Typography>
					<Typography variant='body2'>/ {alignment} for {count} channel </Typography>
				</>
			)
		}

		if (planName == 'Team') {
			let increment = 6;
			alignment == 'monthly' ? increment = 12 : increment = 10;
			amountTeam.current = increment * count;

			return (
				<>
					<Typography variant='h5' component="span">${increment * count}</Typography>
					<Typography variant='body2'>/ {alignment} for {count} channel </Typography>
				</>
			)
		}

		if (planName == 'Agency') {
			let increment = 120;
			alignment == 'monthly' ? increment = 120 : increment = 100;
			let amount = count <= 10 ? increment : increment + (increment * (count - 10));
			amountAgency.current = amount;
			return (
				<>
					{count <= 10 ? <Typography variant='h5' component="span">${increment}</Typography> : <Typography variant='h5' component="span">${increment * (count - 9)}</Typography>}
					<Typography variant='body2'>/ {alignment} for {count} channel </Typography>
				</>
			)
		}
		setAmount(planAmount);
	}

	const handleSubPlan = async (id: any, planName: string) => {
		const subscriptionId = id;
		let planPrice = planName === 'Essentials' ? amountEssentials.current : planName === 'Team' ? amountTeam.current : planName === 'Agency' ? amountAgency.current : 0;
		sessionStorage.setItem('subscriptionId', subscriptionId);
		sessionStorage.setItem('planName', planName);
		sessionStorage.setItem('planPrice', planPrice.toString());
		if (!userId) {
			console.log('User is not logged in');
			navigate(`/authentication/login`);
		} else {
			navigate('/payment');
		}
	}

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', m: 2 }}>
			<Typography variant='h3' align='center' sx={{ marginBottom: '15px' }}>
				Pick your perfect plan
			</Typography>
			<Grid container justifyContent='space-between' maxWidth='40%' sx={{ margin: '10px' }}>
				<Grid item sx={{ display: 'flex', alignItems: 'stretch' }}>
					<Button color="primary" variant="outlined" onClick={decrement} sx={{ borderRadius: '0px', fontSize: '20px', fontWeight: 'bold' }}>-</Button>
					<TextField id="outlined-basic" value={count} variant="filled" sx={{ maxWidth: '55px' }} InputProps={{ inputProps: { style: { textAlign: 'center', fontWeight: 'bold', fontSize: '25px', borderRadius: '0px', backgroundColor: '#79dcfb' } } }}
					/>
					<Button color="primary" variant="outlined" onClick={increment} sx={{ borderRadius: '0px', fontSize: '20px', fontWeight: 'bold' }}>+</Button>
				</Grid>
				<Grid item sx={{ display: 'flex', alignItems: 'stretch' }}>
					<ToggleButtonGroup
						color="primary"
						value={alignment}
						exclusive
						onChange={handleChange}
						aria-label="Platform"
					>
						<ToggleButton value="monthly">Monthly</ToggleButton>
						<ToggleButton value="yearly">Yearly</ToggleButton>
					</ToggleButtonGroup>
				</Grid>
			</Grid>
			<Grid container spacing={2} justifyContent='center' textAlign='center'>
				{dataList && dataList.map((plan: any, index: number) => {
					return (
						<Grid item xs={3} key={index}>
							<Card sx={{ border: 'solid black 1px', maxHeight: '75vh' }}>
								<CardHeader title={<h3>{plan.name}</h3>}></CardHeader>
								<CardContent>
									{/* Need to add a description column in the table*/}
									{plan.name == 'Free' && <Typography>For individuals and businesses getting started with social media.</Typography>}
									{plan.name == 'Essentials' && <Typography> For professionals who use publishing, analytics & engagement tools.</Typography>}
									{plan.name == 'Team' && <Typography>For teams who want unlimited users, collaboration, and reporting.</Typography>}
									{plan.name == 'Agency' && <Typography>For marketing agencies with 10 or more channels.</Typography>}

									<CardActions sx={{ justifyContent: 'center' }}>
										<Button onClick={() => handleSubPlan(plan.id, plan.name)} color="primary" variant='contained'>
											{plan.name !== 'Free' ? 'Try free for 14 days' : 'Get Started'}
										</Button>
									</CardActions>
									<Box sx={{ marginTop: '35px' }}>
										{renderPricing(plan.name)}
									</Box>
									<List sx={{ marginTop: '35px' }}>
										{featureList.map((item: any, index: any) => {
											return <ListItemIcon key={index} sx={{ display: 'flex' }}>
												<Check />
												<Typography>{item}</Typography>
											</ListItemIcon>
										})}
									</List>

								</CardContent>
							</Card>
						</Grid>
					)
				})}
			</Grid>
			<Typography variant='h3' align='center' sx={{ marginBottom: '15px' }}>
				Compare our plans and features
			</Typography>

			<TableContainer component={Paper} sx={{ maxHeight: '100vh', overflowY: 'auto' }}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead >
						<TableRow sx={{
							position: 'sticky', top: 0, zIndex: 1, boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', backgroundColor: (theme) => theme.palette.background.paper
						}}>
							<TableCell></TableCell>
							{dataList && dataList.map((plan: any, index: number) => {
								return (
									<TableCell sx={{ textAlign: 'center' }} key={index}>
										<Typography variant='h4'>{plan.name}</Typography>
										<Button color="primary" variant='contained' onClick={() => handleSubPlan(plan.id, plan.name)}>
											{plan.name !== 'Free' ? 'Try free for 14 days' : 'Get Started'}
										</Button>
									</TableCell>
								)
							})}
						</TableRow>
					</TableHead>
					<TableBody>

						{features && Object.entries(features[0]).map(([key, value]) => {
							return <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								<TableCell component="th" scope="row">
									{key}
								</TableCell>
								{features.map((feature: any, index: number) => (
									<TableCell sx={{ textAlign: 'center' }} key={index}>
										{typeof feature[key] === 'boolean' ? (
											feature[key] ? <Check /> : null
										) : (
											feature[key]
										)}
									</TableCell>
								))}

							</TableRow>
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}


export default Subscriptions;